/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnedBadge
 */
export interface EarnedBadge {
    /**
     * The badge identity, shared with the ladder so a caller can cross-reference the two rows.
     * @type {string}
     * @memberof EarnedBadge
     */
    trackerId: string;
    /**
     * 
     * @type {string}
     * @memberof EarnedBadge
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EarnedBadge
     */
    imageUrl?: string;
    /**
     * When the member first earned it. Never recomputed.
     * @type {number}
     * @memberof EarnedBadge
     */
    earnedAt: number;
    /**
     * How many the member holds. Above one is a duplicate payout, not a second achievement.
     * @type {number}
     * @memberof EarnedBadge
     */
    count: number;
}

/**
 * Check if a given object implements the EarnedBadge interface.
 */
export function instanceOfEarnedBadge(value: object): value is EarnedBadge {
    if (!('trackerId' in value) || value['trackerId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('earnedAt' in value) || value['earnedAt'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function EarnedBadgeFromJSON(json: any): EarnedBadge {
    return EarnedBadgeFromJSONTyped(json, false);
}

export function EarnedBadgeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnedBadge {
    if (json == null) {
        return json;
    }
    return {
        
        'trackerId': json['trackerId'],
        'name': json['name'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'earnedAt': json['earnedAt'],
        'count': json['count'],
    };
}

export function EarnedBadgeToJSON(json: any): EarnedBadge {
    return EarnedBadgeToJSONTyped(json, false);
}

export function EarnedBadgeToJSONTyped(value?: EarnedBadge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trackerId': value['trackerId'],
        'name': value['name'],
        'imageUrl': value['imageUrl'],
        'earnedAt': value['earnedAt'],
        'count': value['count'],
    };
}

